var _rect, _rect2, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg353(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.3076,
    y: 49,
    width: 3,
    height: 12,
    rx: 1.5,
    transform: "rotate(16 28.3076 49)",
    fill: "#01E5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3076,
    y: 49,
    width: 3,
    height: 12,
    rx: 1.5,
    transform: "rotate(16 35.3076 49)",
    fill: "#01E5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0417 25.0956C52.4299 25.1909 51.803 25.2404 51.1646 25.2404C44.4852 25.2404 39.0705 19.8257 39.0705 13.1463C39.0705 11.3059 39.4816 9.56156 40.217 8C34.429 8.90191 30 13.9084 30 19.9493C30 26.6286 35.4147 32.0433 42.094 32.0433C46.933 32.0433 51.1082 29.2014 53.0417 25.0956Z",
    fill: "#CADCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32C42 40.8366 34.8366 48 26 48C17.1634 48 10 40.8366 10 32C10 23.1634 17.1634 16 26 16C34.8366 16 42 23.1634 42 32Z",
    fill: "#E6E7E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 36C54 42.6274 48.6274 48 42 48C35.3726 48 30 42.6274 30 36C30 29.3726 35.3726 24 42 24C48.6274 24 54 29.3726 54 36Z",
    fill: "#E6E7E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 40H42V48H26V40Z",
    fill: "#E6E7E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg353);
export default __webpack_public_path__ + "static/media/353.66e3427dd258f7ec2ba7579a608da85c.svg";
export { ForwardRef as ReactComponent };